export class CardShopStructList {
    productList = []
    market = {}
    total = 0
}
